export default __webpack_public_path__ + "static/media/sun.ed23b430.svg";